<template>
  <v-container grid-list-md text-xs-center>
    <v-layout row wrap>
      <v-toolbar scroll-off-screen scroll-target="#scrolling-activity">
        <v-toolbar-title>{{ $t('activityCentre.title') }}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>

      <v-flex id="scrolling-activity" scroll-y elevation-2 style="min-height: 77vh;" xs12>
        <v-layout justify-space-between row wrap>
          <v-expansion-panel>
            <v-expansion-panel-content>
              <template v-slot:actions>
                <v-icon color="primary">notifications</v-icon>
              </template>
              <template v-slot:header>
                <div>
                  <b>{{ $t("activityCentre.alerts") }}</b>
                </div>
              </template>
              <v-card>
                <v-card-text class="grey lighten-3">
                  <v-list-tile v-for="option in alerts" :key="option.text" @click>
                    <v-list-tile-avatar>
                      <v-icon class="red--text">warning</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>{{ option.text }}</v-list-tile-title>
                    </v-list-tile-content>

                    <v-list-tile-action>
                      <v-btn icon ripple>
                        <v-icon>clear</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                  </v-list-tile>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
            <v-expansion-panel-content v-if="false">
              <template v-slot:actions>
                <v-icon color="primary">$vuetify.icons.expand</v-icon>
              </template>
              <template v-slot:header>
                <div>
                  <b>{{ $t("activityCentre.initialConfiguration") }}</b>
                </div>
              </template>
              <v-card>
                <v-card-text class="grey lighten-3">
                  <v-list>
                    <v-list-group
                      v-for="item in menu"
                      :key="item.text2"
                      :prepend-icon="item.icon"
                      no-action
                    >
                      <template v-slot:activator>
                        <v-list-tile>
                          <v-list-tile-content>
                            <v-list-tile-title>{{ $t(item.text2) }}</v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </template>

                      <v-list-tile v-for="option in item.options" :key="option.text2" @click>
                        <v-list-tile-avatar>
                          <v-icon>{{ option.icon }}</v-icon>
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                          <v-list-tile-title>{{ $t(option.text2) }}</v-list-tile-title>
                        </v-list-tile-content>

                        <v-list-tile-action>
                          <v-btn icon ripple>
                            <v-icon class="green--text" v-if="option.check">check</v-icon>
                            <v-icon class="red--text" v-else>clear</v-icon>
                          </v-btn>
                        </v-list-tile-action>
                      </v-list-tile>
                    </v-list-group>
                  </v-list>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  mounted() {
    if (this.branch != null) {
      this.$store
        .dispatch("employee/getSchoolStats", this.branch.id)
        .then(response => {
          this.$store.dispatch("employee/checkConfiguration");
          this.$forceUpdate();
        });
    }
  },
  computed: {
    alerts() {
      return this.$store.getters["activity/getAlerts"];
    },
    menu() {
      return this.$store.getters["activity/getMenuItems"];
    },
    branch() {
      return this.$store.getters["getBranch"];
    }
  }
};
</script>

<style>
</style>
